import React from "react";
import styled from "styled-components";
import Ribbon from "./ribbon";
import Stars from "./stars";
import MagnifyingGlass from "./magnifyingGlass";
import PalmTrees from "./palmTrees";
import { sangria, jungle } from "@vitalsource/vstui/colors";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import { UnsafeHtml } from "../../../components/mixins";
import { t } from "../../../core/translate";

const StyledBanner = styled.div`
  width: 100%;
  height: 185px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background: ${props =>
    props.color
      ? props.color.getShade(6)
      : props.theme.vstui.color.secondary.getShade(6)};
  background: linear-gradient(
    135deg,
    ${props =>
        props.color
          ? props.color.getShade(6)
          : props.theme.vstui.color.secondary.getShade(6)}
      0%,
    ${props =>
        props.color
          ? props.color.getShade(6)
          : props.theme.vstui.color.secondary.getShade(6)}
      40%,
    ${props =>
        props.color
          ? props.color.getShade(5)
          : props.theme.vstui.color.secondary.getShade(5)}
      40%,
    ${props =>
        props.color
          ? props.color.getShade(5)
          : props.theme.vstui.color.secondary.getShade(5)}
      60%,
    ${props =>
        props.color
          ? props.color.getShade(4)
          : props.theme.vstui.color.secondary.getShade(4)}
      60%,
    ${props =>
        props.color
          ? props.color.getShade(4)
          : props.theme.vstui.color.secondary.getShade(4)}
      100%
  );
  /* stylelint-disable value-no-vendor-prefix */
  background: -ms-linear-gradient(
    135deg,
    ${props =>
        props.color
          ? props.color.getShade(6)
          : props.theme.vstui.color.secondary.getShade(6)}
      0%,
    ${props =>
        props.color
          ? props.color.getShade(6)
          : props.theme.vstui.color.secondary.getShade(6)}
      40%,
    ${props =>
        props.color
          ? props.color.getShade(5)
          : props.theme.vstui.color.secondary.getShade(5)}
      40%,
    ${props =>
        props.color
          ? props.color.getShade(5)
          : props.theme.vstui.color.secondary.getShade(5)}
      60%,
    ${props =>
        props.color
          ? props.color.getShade(4)
          : props.theme.vstui.color.secondary.getShade(4)}
      60%,
    ${props =>
        props.color
          ? props.color.getShade(4)
          : props.theme.vstui.color.secondary.getShade(4)}
      100%
  );
  ${styledMedia.small`
    background: ${props =>
      props.color
        ? props.color.getShade(6)
        : props.theme.vstui.color.secondary.getShade(6)};
  `};
`;

const PseudoButton = styled.div`
  border: 2px solid #fff;
  border-radius: 4px;
  width: 172px;
  height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
`;

const PositionImage = styled.div`
  position: absolute;
  right: ${props => props.right};
  left: ${props => props.left};
  top: ${props => props.top};
  ${styledMedia.tiny`
    display: none;
  `};
`;

const PositionStars = styled.div`
  position: absolute;
  right: 3%;
  top: 15%;
  ${styledMedia.small`
    display: none;
  `};
`;

const PositionText = styled.div`
  padding-left: 27.5px;
  bottom: ${props => props.bottom || "25px"};
  line-height: 4rem;
  font-size: 3.2rem;
  color: ${props => props.theme.vstui.color.white};
  font-weight: 400;
  max-width: 60%;
  ${styledMedia.medium`
    font-size: 3.0rem;
    line-height: 3.4rem;
  `};
  ${styledMedia.small`
    min-width: 162px;
    font-size: 2.2rem;
    line-height: normal;
  `};
  ${styledMedia.tiny`
    max-width: 90%;
    font-size: 1.8rem;
  `};
`;

export const BannerGeneric = props => {
  let rightPosition = "5%";
  if (props.isSmall) {
    rightPosition = "-75px";
  }

  return (
    <StyledBanner>
      {!props.isMedium && (
        <PositionStars>
          <Stars />
        </PositionStars>
      )}
      <PositionImage right={rightPosition} top="-10%">
        <Ribbon />
      </PositionImage>
      <PositionText>
        <div>
          {t(
            "library.banner-promo-one",
            "Find top picks, trending titles and more on the VitalSource Store!"
          )}
        </div>
        <PseudoButton>{t("library.title-books", "Browse Titles")}</PseudoButton>
      </PositionText>
    </StyledBanner>
  );
};

export const BannerStudy = props => {
  let rightPosition = "3%";
  let topPosition = "5%";

  if (props.isSmall) {
    rightPosition = "0px";
  }
  return (
    <StyledBanner color={jungle}>
      <PositionImage right={rightPosition} top={topPosition}>
        <PalmTrees isMedium={props.isMedium} isSmall={props.isSmall} />
      </PositionImage>
      <PositionText>
        <div>
          {t(
            "library.banner-promo-two",
            "Need a study break? Check out the VitalSource store for a breezy weekend read!"
          )}
        </div>
        <PseudoButton>{t("library.browse-books", "Browse Books")}</PseudoButton>
      </PositionText>
    </StyledBanner>
  );
};

export const BannerResearch = props => {
  let rightPosition = "5%";
  if (props.isSmall) {
    rightPosition = "-85px";
  }
  return (
    <StyledBanner color={sangria}>
      <PositionImage right={rightPosition} top="10%">
        <MagnifyingGlass isSmall={props.isSmall} isMedium={props.isMedium} />
      </PositionImage>
      <PositionText bottom="0px">
        <div>
          {t(
            "library.banner-promo-three",
            "Writing a research paper? Get all the titles you need at the VitalSource Store!"
          )}
        </div>
        <PseudoButton>{t("library.shop-books", "Shop Books")}</PseudoButton>
      </PositionText>
    </StyledBanner>
  );
};

export const BannerExplore = props => {
  let rightPosition = "6%";

  if (props.isSmall) {
    rightPosition = "-75px";
  }
  return (
    <StyledBanner>
      <PositionStars>
        <Stars />
      </PositionStars>
      <PositionImage right={rightPosition} top="-10%">
        <Ribbon />
      </PositionImage>
      <PositionText>
        <UnsafeHtml>
          {t(
            "library.banner-explore",
            "Explore top picks, <br /> trending titles and more!"
          )}
        </UnsafeHtml>
      </PositionText>
    </StyledBanner>
  );
};
